import React from 'react';
import { awardEnrichmentApi } from 'components/loyalty/AwardEnrichmentsApi';
import { IAwardEnrichment } from 'components/loyalty/models/AwardEnrichment';
import { enqueueSnackbar } from 'store/notifications/notificationsActions';
import logger from 'lib/logger';
import { PERKS_ITEMS_PER_PAGE } from 'components/perks/PerksGrid';
import { QueryParameter } from 'lib/HttpClient';

const DEFAULT_QUERY_PARAMS: QueryParameter[] = [{ key: 'limit', value: PERKS_ITEMS_PER_PAGE.toString() }];

export const useExternalPerksData = () => {
    const [loading, setLoading] = React.useState(false);

    const [awardEnrichments, setAwardEnrichments] = React.useState<IAwardEnrichment[]>([]);

    const [searchValue, setSearchValue] = React.useState('');

    const handleSearchValueChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(event.target.value);
    }, []);

    React.useEffect(() => {
        const load = async () => {
            let next: string;
            let endOfData = false;
            let loadedAwards: IAwardEnrichment[] = [];

            setLoading(true);

            while (!endOfData) {
                try {
                    const query = next
                        ? [{ key: 'startKey', value: next }, ...DEFAULT_QUERY_PARAMS]
                        : DEFAULT_QUERY_PARAMS;

                    const res = await awardEnrichmentApi.getList({
                        queryParameters: query
                    });

                    if (!res.ok || !res.body.items) {
                        throw new Error(res.body.message);
                    }

                    const {
                        items: awards,
                        page: { nextKey }
                    } = res.body;

                    if (!nextKey) {
                        endOfData = true;
                    }

                    loadedAwards = [
                        ...loadedAwards,
                        ...awards.map((item: IAwardEnrichment) => ({ ...item, id: item._id }))
                    ];

                    next = nextKey;

                    if (!next) {
                        endOfData = true;
                    }
                } catch (e) {
                    logger.error(e.message);
                    enqueueSnackbar('Failed to load awards', { variant: 'error' });
                }
            }

            setAwardEnrichments(loadedAwards);
            setLoading(false);
        };

        load();
    }, [setAwardEnrichments, setLoading]);

    return {
        awardEnrichments,
        loading,
        searchValue,
        setAwardEnrichments,
        handleSearchValueChange
    };
};
